export const API_KEY = 'x-APIKey';
export const CONNECTION_TOKEN = 'x-ConnectionToken';
